import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "ccb:favourites";
const Ctx = createContext(null);
const today = () => new Date().toISOString().slice(0, 10);
const isLive = (o) => {
  const end = o.event_end_date || o.event_date || o.expires_on;
  return !end || end >= today();
};
const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const FavouritesProvider = ({ children }) => {
  const [map, setMap] = useState(() => Object.fromEntries(Object.entries(load()).filter(([, o]) => isLive(o))));
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(map)); }, [map]);
  const toggle = useCallback((o) => setMap((m) => {
    const next = { ...m };
    if (next[o.id]) delete next[o.id];
    else next[o.id] = o;
    return next;
  }), []);
  const value = useMemo(() => {
    const items = Object.values(map).sort((a, b) => (a.event_date || "9999").localeCompare(b.event_date || "9999"));
    return { items, count: items.length, isSaved: (id) => Boolean(map[id]), toggle };
  }, [map, toggle]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useFavourites = () => useContext(Ctx);
